import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

enum KnowledgeBaseDocumentType {
  functionDescription = '1',
  businessRule = '2',
  operationManual = '3',
}

const nameConfig = {
  functionDescription: new Map([
    [Locale.ja, '機能説明'],
    [Locale.en, 'Function Description'],
  ]),
  businessRule: new Map([
    [Locale.ja, '業務ルール'],
    [Locale.en, 'Business Rule'],
  ]),
  operationManual: new Map([
    [Locale.ja, '操作マニュアル'],
    [Locale.en, 'Operation Manual'],
  ]),
};

const toEnum = rawValueToEnum(KnowledgeBaseDocumentType, KnowledgeBaseDocumentType.functionDescription);
const toDisplay = enumToName(KnowledgeBaseDocumentType, nameConfig);
const toDisplayWithPrefix = enumToName(KnowledgeBaseDocumentType, nameConfig, { prefix: true });

export const knowledgeBaseDocumentType = {
  enum: KnowledgeBaseDocumentType,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { KnowledgeBaseDocumentType };
